// src/i18n/es/events.ts

/**
 * Spanish translations for Events feature
 */
const events = {
  name: 'Eventos',
  title: 'Eventos',

  // Help
  help: {
    page: 'Ver todos los eventos del sistema incluyendo operaciones, heartbeats y errores. Usa los filtros para encontrar eventos específicos o buscar por metadata. «Desde» y «Hasta» son días del hotel: cada día va de la hora de cierre del hotel (las 04:00 si no tiene otra) a la misma hora del día siguiente, en su zona horaria.',
  },

  // Fields
  fields: {
    createdAt: 'Fecha/Hora',
    eventCode: 'Tipo de Evento',
    device: 'Dispositivo',
    reservation: 'Reserva',
    hotel: 'Instalación',
    channel: 'Canal',
    status: 'Estado',
    metadata: 'Metadata',
    errorCode: 'Código de Error',
  },

  // Filters
  filters: {
    reservation: 'Buscar por reserva',
    roomNumber: 'Buscar por habitación',
    group: 'Grupo',
    allGroups: 'Todos los grupos',
    hotel: 'Instalación',
    device: 'Dispositivo',
    eventCode: 'Tipo de Evento',
    channel: 'Canal',
    status: 'Estado',
    dateFrom: 'Fecha desde',
    dateTo: 'Fecha hasta',
    showHeartbeats: 'Mostrar Heartbeats',
    showFilters: 'Mostrar filtros',
  },

  // Event codes
  eventCodes: {
    // Legacy short codes
    HB: 'Heartbeat',
    PCO: 'Pre Check-in Abierto',
    PCF: 'Pre Check-in Finalizado',
    CIO: 'Check-in Abierto',
    CIF: 'Check-in Finalizado',
    KDO: 'Dispensación de Llave Abierta',
    KDF: 'Dispensación de Llave Finalizada',
    ERR: 'Error',
    COO: 'Check-out Abierto',
    COF: 'Check-out Finalizado',

    // Check-in flow
    CI_START: 'Check-in iniciado',
    CI_SEARCH: 'Búsqueda de reserva',
    CI_IDENTIFY: 'Identificación del huésped',
    CI_SIGN: 'Firma',
    CI_UPSELL: 'Venta adicional',
    CI_COMP: 'Check-in completado',

    // Pre-check-in flow
    PC_LINK_OPEN: 'Enlace abierto',
    PC_START: 'Pre-check-in iniciado',
    PC_SEARCH: 'Búsqueda de reserva',
    PC_IDENTIFY: 'Identificación del huésped',
    PC_SIGN: 'Firma',
    PC_UPSELL: 'Venta adicional',
    PC_COMP: 'Pre-check-in completado',

    // Section navigation
    SECTION_ENTER: 'Entrada a sección',
    SECTION_EXIT: 'Salida de sección',

    // Payment
    PM_SUCCESS: 'Pago realizado',
    PM_ERROR: 'Error en el pago',

    // Key delivery
    KD_SUCCESS: 'Llave entregada',
    KD_ERROR: 'Error al entregar la llave',
    KD_REBOOT: 'Reinicio del dispensador',

    // Operational / errors
    PMS_RECOVERY_FAILED: 'Fallo de recuperación',
    PMS_RESERVATION_NOT_FOUND: 'Reserva no encontrada',
    PMS_ROOM_NOT_READY: 'Habitación no disponible',
    AB: 'Sesión abandonada',
  },

  // Channels
  channels: {
    Kiosk: 'Kiosco',
    Dispenser: 'Dispensador de llaves',
    Online: 'Pre-check-in online',
    AirLobby: 'Air Lobby',
    MobileKiosk: 'Kiosco en el móvil',
  },

  // Status
  status: {
    completed: 'Completado',
    started: 'Iniciado',
    error: 'Error',
    unknown: 'Desconocido',
  },

  // Metadata
  metadata: {
    title: 'Metadata del Evento',
    view: 'Ver metadata',
    copyJson: 'Copiar como JSON',
    empty: 'No hay metadata disponible',
    searchTitle: 'Buscar por Metadata',
    searchDescription: 'Encuentra eventos que contengan una clave y valor de metadata específicos.',
    searchButton: 'Buscar por Metadata',
    searchActive: 'Buscando eventos con metadata: %{key} = %{value}',
    key: 'Clave de Metadata',
    value: 'Valor de Metadata',
    keyRequired: 'La clave de metadata es obligatoria',
    valueRequired: 'El valor de metadata es obligatorio',
    dateRange: 'Rango de Fechas (opcional)',
    expand: 'Expandir metadata',
    collapse: 'Contraer metadata',
  },

  // Errors
  errors: {
    loadFailed: 'Error al cargar eventos',
  },

  // Bulk delete (SuperAdmin)
  bulkDelete: {
    deleteSelected: 'Eliminar seleccionados',
    deleteByFilters: 'Eliminar todos según filtros',
    confirmTitle: 'Confirmar eliminación',
    confirmMessage: 'Está a punto de eliminar permanentemente %{count} evento. Esta acción no se puede deshacer. |||| Está a punto de eliminar permanentemente %{count} eventos. Esta acción no se puede deshacer.',
    confirmByFiltersMessage: 'Está a punto de eliminar permanentemente TODOS los eventos que coinciden con los filtros actuales. Esta acción no se puede deshacer.',
    irreversible: 'Esta acción es irreversible. Los eventos eliminados no se pueden recuperar.',
    deleting: 'Eliminando...',
    successMessage: '%{count} evento eliminado correctamente |||| %{count} eventos eliminados correctamente',
    errorMessage: 'Error al eliminar eventos',
    selected: '%{count} seleccionado |||| %{count} seleccionados',
    clearSelection: 'Limpiar selección',
    selectAll: 'Seleccionar todos',
  },
};

export default events;
